import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const userRoleSwitch = createAsyncThunk(
  "userRoleSwitch",
  async (data) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.post(
        `${API_KEY}/api/president/add-sub-president`,
        data,
        {
          headers: { Authorization: `Barear ${token}` },
          "Content-Type": "application/json",
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  userRoleSwitchData: null,
  isError: false,
  errorMessage: "",
};
const userRoleSwitchSlice = createSlice({
  name: "userRoleSwitch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userRoleSwitch.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(userRoleSwitch.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userRoleSwitchData = action.payload;
    });
    builder.addCase(userRoleSwitch.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default userRoleSwitchSlice.reducer;
